var React = require('react');

function MyProfileExitIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"20","style":{"fill":"none"},"key":0}),React.createElement("path",{"id":"user-logout","d":"M7,.9C4.5.9,2.4,2.9,2.4,5.4s2,4.6,4.6,4.6,4.6-2,4.6-4.6c0-2.5-2-4.5-4.6-4.6ZM7,8.5c-1.7,0-3-1.4-3-3s1.4-3,3-3c1.7,0,3,1.4,3,3,0,0,0,0,0,0,0,1.7-1.4,3-3,3ZM4.3,11.5h4.9v1.5h-4.9c-1,0-1.9.9-1.9,1.9v4.2H.9v-4.2c0-1.9,1.5-3.4,3.4-3.4ZM13,17.6h1.5v1.5h-1.5c-1.3,0-2.3-1-2.3-2.3v-4.6c0-1.3,1-2.3,2.3-2.3h1.5v1.5h-1.5c-.4,0-.8.3-.8.8v4.6c0,.4.3.8.8.8,0,0,0,0,0,0ZM19.1,14.6c0,.4-.2.8-.5,1.1l-2,1.8-1-1.1,1.2-1h-2.9v-1.5h2.8l-1.1-.9,1-1.1,2,1.8c.3.3.5.7.5,1.1h0Z","style":{"fill":"#6d28d9"},"key":1})]);
}

MyProfileExitIcon.defaultProps = {"id":"Layer_1","width":"20","height":"20","version":"1.1","viewBox":"0 0 20 20"};

module.exports = MyProfileExitIcon;

MyProfileExitIcon.default = MyProfileExitIcon;
